import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex flex-col lg:flex-row w-full min-h-screen bg-white" }
const _hoisted_2 = { class: "w-full lg:w-5/12 h-[50vh] lg:h-screen lg:sticky top-0 overflow-hidden bg-gray-50" }
const _hoisted_3 = { class: "relative w-full h-full" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "w-full lg:w-7/12 p-6 lg:p-12" }
const _hoisted_7 = { class: "sticky top-4 z-50 bg-white/90 backdrop-blur-md px-6 py-6 border border-gray-100 mb-12 rounded-3xl shadow-xl shadow-gray-200/50" }
const _hoisted_8 = { class: "flex flex-col xl:flex-row xl:items-center justify-between gap-8" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em] mb-1" }
const _hoisted_11 = { class: "flex items-baseline gap-3" }
const _hoisted_12 = { class: "text-3xl font-black text-brand-main tracking-tight" }
const _hoisted_13 = { class: "text-xs text-gray-500 font-semibold" }
const _hoisted_14 = { class: "flex flex-wrap items-center gap-x-8 gap-y-6" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-col gap-2.5"
}
const _hoisted_16 = { class: "text-[10px] font-extrabold text-gray-400 uppercase tracking-widest" }
const _hoisted_17 = {
  key: 0,
  class: "flex items-center rounded-full bg-gray-100 p-1 ring-1 ring-gray-200"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "flex items-center gap-2.5"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "absolute -top-10 left-1/2 -translate-x-1/2 px-2 py-1 bg-brand-main text-white text-[10px] rounded-md opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-[60] shadow-xl" }
const _hoisted_23 = { class: "flex items-center gap-4 mb-8" }
const _hoisted_24 = { class: "text-xs font-black text-gray-400 uppercase tracking-[0.3em] flex items-center gap-3" }
const _hoisted_25 = { class: "w-6 h-6 rounded-full bg-brand-main text-white flex items-center justify-center text-[10px]" }
const _hoisted_26 = { class: "grid grid-cols-1 md:grid-cols-2 gap-10" }
const _hoisted_27 = ["data-item-idx", "onMouseover"]
const _hoisted_28 = { class: "relative aspect-[4/5] rounded-[2rem] overflow-hidden bg-gray-50 mb-6" }
const _hoisted_29 = { class: "absolute top-5 right-5 flex flex-col gap-3 opacity-0 translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500" }
const _hoisted_30 = { class: "px-2 flex-grow flex flex-col" }
const _hoisted_31 = { class: "text-lg font-bold text-gray-900 mb-2 leading-tight group-hover:text-brand-main transition-colors" }
const _hoisted_32 = { class: "mt-auto pt-4 flex justify-between items-end" }
const _hoisted_33 = { class: "flex flex-col" }
const _hoisted_34 = { class: "text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1" }
const _hoisted_35 = { class: "text-xl font-black text-brand-main" }

import {computed, onMounted, onUnmounted, ref} from "vue";
import {useI18n} from "vue-i18n";
import {useStore} from "vuex";
import ItemImage from "@/components/itemImage.vue";

const pageStr = 'components.itemV2.itemV2ShopTheLook'


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV2ShopTheLook',
  props: ["session"],
  emits: ["patchSet", "addPerson", "removePerson", "addItemToPerson"],
  setup(__props, { emit: __emit }) {

const {t} = useI18n();
const store = useStore();

const props = __props;
const emit = __emit;

const teaserItemImage = ref<number>(0)
const teaserItemImagePos = ref<number>(1)

const itemRefs = ref<HTMLElement[]>([]);
let observer: IntersectionObserver | null = null;

const setItemRef = (el: any) => {
  if (el) {
    if (!itemRefs.value.includes(el)) {
      itemRefs.value.push(el);
      observer?.observe(el);
    }
  }
};

onMounted(() => {
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
        const itemIdx = entry.target.getAttribute("data-item-idx");
        if (itemIdx !== null) {
          teaserItemImage.value = parseInt(itemIdx);
          teaserItemImagePos.value = 1;
        }
      }
    });
  }, {
    root: null,
    rootMargin: '-20% 0px -20% 0px',
    threshold: [0, 0.3, 0.5]
  });
});

onUnmounted(() => {
  observer?.disconnect();
});

const teaserImage = computed(() => {
  if (props.session.items[teaserItemImage.value] && props.session.items[teaserItemImage.value].image.positions[teaserItemImagePos.value]) {
    return props.session.items[teaserItemImage.value].image.positions[teaserItemImagePos.value].filename || ""
  } else {
    return ""
  }
})

const totalPrice = computed(() => {
  let total = 0
  if (props.session.items) {
    for (const itemIdx in props.session.items) {
      total += props.session.items[itemIdx].price.total
    }
  }
  return total
})

const patchSet = (variantValueData: { value: string, itemIdx: { [key: string]: string } }) => {

  const items: { itemIdx: string, valueIdx: string }[] = []

  for (const itemIdx in variantValueData.itemIdx) {
    items.push({
      itemIdx: parseInt(itemIdx.replace("itemIdx:", "") as string),
      valueIdx: variantValueData.itemIdx[itemIdx]
    })
  }

  emit("patchSet", {
    value: variantValueData.value,
    items: items
  })
}

const extractVariants = (searchIdx: string) => {
  const rawList = {}
  const finalList = {}
  const numberOfItems = Object.keys(props.session.items).length

  if (props.session.items) {
    for (const itemIdx in props.session.items) {
      for (const variantIdx in props.session.items[itemIdx]["variants"]) {
        if (
            props.session.items[itemIdx]["variants"][variantIdx].idx == searchIdx ||
            props.session.items[itemIdx]["variants"][variantIdx].idx.includes("." + searchIdx)
        ) {

          for (const colorIdx in props.session.items[itemIdx]["variants"][variantIdx].values) {
            const valueIdx = props.session.items[itemIdx]["variants"][variantIdx].values[colorIdx].idx as string
            if (!rawList[valueIdx]) {
              rawList[valueIdx] = {
                "title": props.session.items[itemIdx]["variants"][variantIdx].values[colorIdx].title,
                "image": props.session.items[itemIdx]["variants"][variantIdx].values[colorIdx].image,
                "order": props.session.items[itemIdx]["variants"][variantIdx].values[colorIdx].order,
                "match": props.session.items[itemIdx]["variants"][variantIdx].values[colorIdx].match,
                "value": valueIdx,
                "itemIdx": {}
              }
            }

            rawList[valueIdx]["itemIdx"]["itemIdx:" + itemIdx] = props.session.items[itemIdx]["variants"][variantIdx].idx
          }
        }
      }
    }
  }

  /**
   * check if color is possible in every item
   */

  for (const valueIdx in rawList) {
    if (Object.keys(rawList[valueIdx]["itemIdx"]).length === numberOfItems) {
      finalList[valueIdx] = rawList[valueIdx]
    }
  }

  return finalList
}

const setVariants = computed(() => {
  return {
    color: extractVariants("color"),
    metal: extractVariants("metal"),
    stone_type: extractVariants("stone_type"),
    stone_quality: extractVariants("stone_quality")
  }
})

const variantsText = computed(() => {
  return {
    color: t(pageStr + '.color'),
    metal: t(pageStr + '.metal'),
    stone_type: t(pageStr + '.stone_type'),
    stone_quality: t(pageStr + '.stone_quality')
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (teaserImage.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (teaserImage.value.includes('.webp'))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: teaserImage.value,
                        src: teaserImage.value,
                        class: "object-cover h-full w-full",
                        alt: "Teaser"
                      }, null, 8, _hoisted_4))
                    : (_openBlock(), _createElementBlock("video", {
                        key: 'video-' + teaserImage.value,
                        class: "object-cover h-full w-full",
                        autoplay: "",
                        loop: "",
                        muted: "",
                        playsinline: ""
                      }, [
                        _createElementVNode("source", {
                          src: teaserImage.value,
                          type: "video/mp4"
                        }, null, 8, _hoisted_5),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(pageStr + '.your_browser_does_not_support_the')), 1)
                      ]))
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-r from-black/10 to-transparent pointer-events-none" }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("nav", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t(pageStr + '.customize_your_set')), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$n(totalPrice.value, "currency")), 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t(pageStr + '.set_price')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(setVariants.value, (variantList, variantIdx) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: variantIdx }, [
                (Object.keys(variantList).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(variantsText.value[variantIdx]), 1),
                      (variantIdx == 'stone_type')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['earth', 'lab'], (typeKey, typeIdx) => {
                              return _createElementVNode("button", {
                                key: typeKey + typeIdx,
                                type: "button",
                                class: _normalizeClass(["min-w-[80px] rounded-full px-4 py-1.5 text-[10px] font-bold tracking-wider transition-all duration-300 focus:outline-none", setVariants.value['stone_type'][typeKey]?.match ? 'bg-brand-main text-white shadow-lg shadow-brand-main/20 ring-1 ring-brand-main' : 'text-gray-500 hover:text-gray-700']),
                                onClick: ($event: any) => (patchSet(setVariants.value['stone_type'][typeKey]))
                              }, _toDisplayString(_ctx.$t(pageStr + '.' + (typeKey === 'earth' ? 'natural' : 'lab'))), 11, _hoisted_18)
                            }), 64))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variantList, (valueData, valueIdx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: valueIdx,
                                class: "cursor-pointer transition-all duration-300 relative group",
                                onClick: ($event: any) => (patchSet(valueData))
                              }, [
                                (variantIdx == 'metal' || variantIdx == 'stone_quality')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass(["px-3 py-1.5 rounded-xl text-[10px] font-black border transition-all duration-300", valueData.match ? 'bg-brand-main text-white border-brand-main shadow-lg shadow-brand-main/20 transform scale-105' : 'bg-white text-gray-600 border-gray-200 hover:border-gray-400'])
                                    }, _toDisplayString(valueData.value.toUpperCase()), 3))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: _normalizeClass(["relative p-0.5 rounded-full border-2 transition-all duration-300", valueData.match ? 'border-brand-main shadow-lg shadow-brand-main/20 transform scale-110' : 'border-transparent hover:border-gray-300'])
                                    }, [
                                      _createElementVNode("img", {
                                        src: 'https://rubin-website-images.s3.eu-central-1.amazonaws.com/assets/colors/' + valueData.value.toLowerCase() + '@2x.jpg',
                                        alt: "",
                                        class: "rounded-full object-cover h-6 w-6 border border-gray-100"
                                      }, null, 8, _hoisted_21),
                                      _createElementVNode("span", _hoisted_22, _toDisplayString(valueData.title), 1)
                                    ], 2))
                              ], 8, _hoisted_20))
                            }), 128))
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.session.persons, (person, personIdx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: 'person' + personIdx,
          class: "mb-20"
        }, [
          _createElementVNode("div", _hoisted_23, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "h-px flex-grow bg-gray-100" }, null, -1)),
            _createElementVNode("h3", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(personIdx + 1), 1),
              _createTextVNode(" " + _toDisplayString(person.name || _ctx.$t(pageStr + '.person_n', { n: personIdx + 1 })), 1)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "h-px flex-grow bg-gray-100" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_26, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(person.items, (itemIdx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'person' + personIdx + 'Item' + itemIdx,
                ref_for: true,
                ref: setItemRef,
                "data-item-idx": itemIdx,
                onMouseover: ($event: any) => {teaserItemImage.value=itemIdx; teaserItemImagePos.value=1},
                class: "group relative flex flex-col bg-white rounded-[2.5rem] p-5 transition-all duration-500 hover:shadow-2xl hover:shadow-gray-200/50 border border-gray-50"
              }, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_router_link, {
                    to: '/conf/' + __props.session.session_id + '/' + itemIdx,
                    onClick: ($event: any) => {_unref(store).commit('session/setViewMode', 'item'); _unref(store).commit('session/setItemIdx', itemIdx)},
                    class: "block w-full h-full"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ItemImage, {
                        "image-url": __props.session.items[itemIdx].image.filename,
                        "image-layer-url": __props.session.items[itemIdx].image.filename_layer,
                        "main-metal": __props.session.items[itemIdx].image.main_metal,
                        zoom: false,
                        class: "w-full h-full object-contain transition-transform duration-1000 group-hover:scale-110"
                      }, null, 8, ["image-url", "image-layer-url", "main-metal"]),
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" }, null, -1))
                    ]),
                    _: 2
                  }, 1032, ["to", "onClick"]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_router_link, {
                      to: '/conf/' + __props.session.session_id + '/' + itemIdx,
                      onClick: ($event: any) => {_unref(store).commit('session/setViewMode', 'item'); _unref(store).commit('session/setItemIdx', itemIdx)},
                      class: "p-3 bg-white/90 backdrop-blur-xl rounded-2xl shadow-xl hover:bg-brand-main hover:text-white transition-all duration-300"
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "w-5 h-5",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                          })
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["to", "onClick"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("h4", _hoisted_31, _toDisplayString(__props.session.items[itemIdx].desc.title), 1),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t(pageStr + '.price')), 1),
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$n(__props.session.items[itemIdx].price.total, "currency")), 1)
                    ]),
                    _createVNode(_component_router_link, {
                      to: '/conf/' + __props.session.session_id + '/' + itemIdx,
                      onClick: ($event: any) => {_unref(store).commit('session/setViewMode', 'item'); _unref(store).commit('session/setItemIdx', itemIdx)},
                      class: "text-[10px] font-black text-brand-main hover:opacity-60 uppercase tracking-[0.2em] flex items-center gap-2 transition-all group/link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(pageStr + '.details')) + " ", 1),
                        _cache[5] || (_cache[5] = _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M17 8l4 4m0 0l-4 4m4-4H3"
                          })
                        ], -1))
                      ]),
                      _: 1
                    }, 8, ["to", "onClick"])
                  ])
                ])
              ], 40, _hoisted_27))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})